import React from "react";
import connect from "Shared/connect";
import * as styles from "../base.scss";
import MyMenigoIcon, { GetIcons, } from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import classnames from "classnames";
import Image from "Shared/ImageFallback";
import { pushState } from "Shared/history";
const LoginSlider = (props) => (React.createElement("div", { className: styles.slideIn, key: "MyMenigo" }, props.myMenigoItems
    .filter((item) => item.disabledForGuestUsers)
    .map((item) => (React.createElement("a", { key: item.url, onClick: () => pushState(item.url) },
    React.createElement("div", { className: classnames(styles.primary, styles.menuLinks) },
        React.createElement("span", null,
            !item.menuIcon ? (React.createElement(MyMenigoIcon, { name: GetIcons(item.name) })) : (React.createElement(Image, { src: item.menuIcon })),
            item.name),
        !!item.textMark && (React.createElement("span", { className: styles.menuTextMark }, item.textMark)),
        React.createElement(MyMenigoIcon, { name: "arrow" })))))));
export default connect((state) => ({
    myMenigoItems: !!state.appShellData.header && state.appShellData.header.myMenigoItems,
}))(LoginSlider);
